export default function trimSlug(slug: string) {
  return slug.replaceAll("/", " ").trim().replaceAll(" ", "/")
}
